"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedNavigationItemBorder = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AnimatedNavigationItemBorder = function AnimatedNavigationItemBorder(_ref) {
  var active = _ref.active;
  return _react["default"].createElement(_box["default"], {
    height: 3,
    width: active ? 1 : 0,
    bg: "wagGreen",
    position: "absolute",
    right: active ? 'auto' : 0,
    left: active ? 0 : 'auto',
    bottom: "-5px",
    transition: "0.2s linear width"
  });
};

exports.AnimatedNavigationItemBorder = AnimatedNavigationItemBorder;